// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","entry":"Header_entry__vAOag"};